import { Loader2 } from "lucide-react";
import type { JobStatus } from "@/application/tools/types";

const STATUS_COLOURS: Record<JobStatus, string> = {
  pending: "bg-muted text-foreground",
  running: "bg-blue-100 text-blue-700",
  complete: "bg-green-100 text-green-700",
  failed: "bg-red-100 text-red-700",
  cancelled: "bg-amber-100 text-amber-700",
};

export function JobStatusBadge({ status }: { status: JobStatus }) {
  return (
    <span
      // eslint-disable-next-line security/detect-object-injection -- status is a typed JobStatus literal
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium capitalize ${STATUS_COLOURS[status]}`}
    >
      {status === "running" && (
        <Loader2
          className="h-3 w-3 animate-spin"
          data-testid="running-spinner"
        />
      )}
      {status}
    </span>
  );
}
